import React from "react";
import {useEffect, useRef} from "react";

function TaskInput({
    title,
    description,
    priority,
    dueDate,
    addTask,
    setTitle,
    setDescription,
    setPriority,
    setDueDate
}) {
    const inputRef = useRef(null);
    useEffect(() => {
        inputRef.current?.focus();
    }, []);

    return (
        <div className="form">
            <input
            type="text"
            placeholder="Task title"
            ref={inputRef}
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            onKeyDown={(e) => {
                if (e.key === "Enter") addTask();
            }}
            className = "input"
            />

            <input
            type="text"
            placeholder="Task description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            onKeyDown={(e) => {
                if (e.key === "Enter") addTask();
            }}
            className = "input"
            />

            <select
            value={priority}
            onChange={(e) => setPriority(e.target.value)}
            className="input"
            >
            <option value="low">Low</option>
            <option value="medium">Medium</option>
            <option value="high">High</option>
            </select>

            <input 
            type="date"
            value={dueDate}
            onChange={(e) => setDueDate(e.target.value)}
            onKeyDown={(e) => {
                if (e.key === "Enter") addTask();
            }}
            className="input"
            />

            <button onClick={addTask} className="add" disabled={!title.trim()}>Add Task</button>
        </div>
    )
}

export default TaskInput;